import { createContext, useContext } from "react";
import { SUPPORTED_LANGUAGES_TYPE } from "../../i18n";
import {
  AuthCustomerUser,
  CPContactPerson,
  CustomerUserLoginRequest,
  CustomerUserLoginResult,
} from "../../api/models/unified";

export const useAuth = () => {
  return useContext(AuthContext);
};

export interface AuthContextType {
  user?: AuthCustomerUser;
  authenticated: boolean;
  loading: boolean;
  onLogin: (values: CustomerUserLoginRequest) => Promise<void>;
  onLogout: () => Promise<void>;
  onChangeCustomer: (customerId: string) => Promise<void>;
  onAdminLogin: (loginResult: CustomerUserLoginResult) => Promise<void>;
  setUser: (user: AuthCustomerUser) => void;
  setAuthenticated: (authenticated: boolean) => void;
  language?: SUPPORTED_LANGUAGES_TYPE;
  setLanguage: (code: SUPPORTED_LANGUAGES_TYPE) => void;
  otherAccounts: CPContactPerson[];
  setOtherAccounts: (accounts: CPContactPerson[]) => void;
  customerIsChanging: boolean;
  isAdminMode: boolean;
  setIsAdminMode: (isAdminMode: boolean) => void;
}

export const AuthContext = createContext<AuthContextType>({
  authenticated: false,
  loading: true,
  onLogin: () => Promise.resolve(),
  onLogout: () => Promise.resolve(),
  onChangeCustomer: () => Promise.resolve(),
  onAdminLogin: () => Promise.resolve(),
  setUser: () => {
    // nothing
  },
  setAuthenticated: () => {
    // nothing
  },
  language: "cs",
  setLanguage: () => {
    // nothing
  },
  otherAccounts: [],
  setOtherAccounts: () => {
    // nothing
  },
  customerIsChanging: false,
  isAdminMode: false,
  setIsAdminMode: () => {
    // nothing
  },
});
